import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import SicurezzaArticle from "../pages/article/sicurezza";
import ConfrontoArticle from "../pages/article/confronto";
import ErroriArticle from "../pages/article/errori";
import ComeUsareArticle from "../pages/article/come-usare";
import FAQArticle from "../pages/article/faq";
import MiglioriProdottiArticle from "../pages/article/migliori-prodotti";
import GratisArticle from "../pages/article/gratis";
import AvanzataArticle from "../pages/article/avanzata";
import AlternativeArticle from "../pages/article/alternative";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/articolo/guida-completa-itaobuy-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/articolo/sicurezza-itaobuy-spreadsheet",
    element: <SicurezzaArticle />,
  },
  {
    path: "/articolo/confronto-itaobuy-spreadsheet",
    element: <ConfrontoArticle />,
  },
  {
    path: "/articolo/errori-comuni-itaobuy-spreadsheet",
    element: <ErroriArticle />,
  },
  {
    path: "/articolo/come-usare-itaobuy-spreadsheet",
    element: <ComeUsareArticle />,
  },
  {
    path: "/articolo/faq-itaobuy-spreadsheet",
    element: <FAQArticle />,
  },
  {
    path: "/articolo/migliori-prodotti-itaobuy-spreadsheet",
    element: <MiglioriProdottiArticle />,
  },
  {
    path: "/articolo/spreadsheet-gratis-itaobuy",
    element: <GratisArticle />,
  },
  {
    path: "/articolo/guida-avanzata-itaobuy",
    element: <AvanzataArticle />,
  },
  {
    path: "/articolo/alternative-itaobuy-spreadsheet",
    element: <AlternativeArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;